import React from 'react';
import { Route, Redirect } from 'react-router-dom'
// import {PropRoute} from 'services/CommonService.jsx'

import { MenuItem } from 'react-bootstrap';
import { API, STORAGE } from 'services/CommonService.jsx'
import { CACHE } from 'services/DataService.jsx'
import moment from 'moment';
import store from "redux/store/index";
import { setFlags } from "redux/actions/index";

import Log from 'services/Log.jsx'



const AUTH_PATHS = {
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgotpassword',
  PASSWORD_RESET: '/passwordreset/:token'
};

const Authenticator = {
  authenticated: STORAGE.getBoolean("authenticated"),
  token: localStorage.getItem("token"),
  user: {},
  projects: [],
  requestVerifyEmail: function (callback) {
      API.GET("/auth/v1/sendverify", (response) => {
          callback(response);
      });
  },
  isUserDataExpired: function() {
    Log.debug("DURATION check")
    if (this.user && this.user.timestamp) {
      var duration = moment.duration(moment(this.user.timestamp).diff(moment(new Date())));
      Log.debug("DURATION", duration);
      Log.debug("DURATION", duration.asSeconds());
      Log.debug("DURATION", -1 * duration.asSeconds() > 60);
      return -1 * duration.asSeconds() > 60;
    } else {
      return true;
    }
  },
  getUser: function(callback) {
    var self = this;
    Log.debug("duration debug", this.user);
    if(this.user && this.user.email && !this.isUserDataExpired()) {
      callback(this.user);
    } else {
      Log.debug("duraition fetching");
      this.fetchUser((user) => {
        self.user = user;
        self.user.timestamp = new Date();
        Log.debug("duration fetched", self.user);
        callback(self.user);
      });
    }
  },
  refreshUser: function(callback) {
    this.user = {};
    this.projects = [];
    CACHE.CLEAR();
    this.fetchUser(callback);
  },
  fetchUser: function(callback) {
    API.GET("/app/v1/user", (response) => {
      if (response.success) {
        this.user = response.data;
        store.dispatch(setFlags(response.data.featureFlags));
      } else {
        Log.debug("error getting user");
        Log.debug(response);
        Authenticator.signout(() => {
          window.location.href = "/";
        });
      }
      callback(this.user);
    });
  },
  getProjects: function(callback) {
    if(this.projects && this.projects.length > 0) {
      callback(this.projects);
    } else {
      this.fetchProjects((projects) => {
        this.projects = projects;
        callback(this.projects);
      });
    }
  },
  fetchProjects: function(callback) {
    API.GET("/app/v1/project", (response) => {
      if (response.success) {
        this.projects = response.data.projects;
      } else {
        Log.debug("error getting projects");
        Log.debug(JSON.stringify(response));
      }
      callback(this.projects);
    });
  },
  deleteProject: function(callback) {
    API.DELETE("/app/v1/project", (response) => {
      if (response.success) {
        this.projects = response.data.projects;
      } else {
        Log.debug("error getting projects");
        Log.debug(JSON.stringify(response));
      }
      callback(response);
    });
  },

  forgotPassword: function(email, callback) {
      API.POST("/auth/v1/forgot_password", {data: email}, (response) => {
          callback({success: response.success});
      });
  },
  resetPassword: function(token, data, callback) {
    API.POST("/auth/v1/reset_password/" + token, data, (response) => {
        callback(response);
    });
  },
    verifyEmail: function(token, callback) {
      API.GET("/auth/v1/verify/" + token, (response) => {
          callback(response);
      });
  },
  authenticate: function(username, password, callback) {
    Log.debug("[AuthService - authenticate] start");
    API.POST("/auth/v1/login", {email: username, password: password}, (response) => {
      Log.debug(JSON.stringify(response));
      var e = new Error();
      Log.debug(e.stack);
      if (response.success) {
        this.authenticated = true;
        localStorage.setItem("authenticated", true);
        localStorage.setItem("token", response.data.token);
        this.user = response.data.user;
        this.token = response.data.token;
        this.projects = response.data.projects;
        Log.debug("[AuthService - authenticate] end 1");
        callback({success: true});
      } else {
        this.authenticated = false;
        this.user = {};
        this.projects = {};
        localStorage.setItem("authenticated", false);
        localStorage.setItem("token", "");
        Log.debug("[AuthService - authenticate] end 2");
        callback({success: false, errors: response.errors });
      }
    });
  },
  signout: function(callback) {
    this.authenticated = false;
    localStorage.setItem("authenticated", false);
    localStorage.setItem("token", "");
    this.user = {};
    this.projects = {};
    callback();
  },
  register: function(fields, callback) {
    API.POST("/auth/v1/register", fields, (response) => {
      if (response.success) {
        this.authenticated = true;
        localStorage.setItem("authenticated", true);
        localStorage.setItem("token", response.data.token);
        console.log("[regData] " + JSON.stringify(response, null, 2));
        var self = this;
        (function one(){
          console.log("verifying local storage");
           if (localStorage.getItem("token") === response.data.token) {
             self.user = response.data.user;
             self.token = response.data.token;
             self.projects = response.data.projects;
             callback({success: true});
           } else {
              setTimeout(one, 30);
           }
        })();
      } else {
        this.authenticated = false;
        localStorage.setItem("authenticated", false);
        localStorage.setItem("token", "");
        this.user = {};
        this.projects = {};
        this.token = "";
        callback({success: false, errors: response.errors });
      }
    });
  },
  update: function(fields, callback) {
    API.PUT("/app/v1/user", fields, (response) => {
      if (response.success) {
        this.user = response.data.user;
        callback({success: true});
      } else {
        callback({success: false, errors: response.errors });
      }
    });
  }
};

class Logout extends React.Component {
  state = {
    redirectToLogin: false
  };
  logout = () => {
    Authenticator.signout(() => {
      this.setState(() => ({
        redirectToLogin: true
      }))
    })
  };
  render() {
    const { redirectToLogin } = this.state;
    if (String(redirectToLogin) === 'true') {
      return (<Redirect to={AUTH_PATHS.LOGIN} />);
    } else {
      return (
        <MenuItem onClick={this.logout}><div className="text-danger"><i className="pe-7s-close-circle"></i> Log out</div></MenuItem>
      )
    }
  }
}

const AuthenticatedRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (
    Authenticator.authenticated === true ? (
      <Component {...props}/>
    ) : (
      <Redirect to={{
        pathname: AUTH_PATHS.LOGIN,
        state: { from: props.location }
      }}/>
    )
  )}/>
);

export { Authenticator, AuthenticatedRoute, Logout, AUTH_PATHS }



// WEBPACK FOOTER //
// ./src/services/AuthService.jsx